import * as R from 'ramda';
import { requestWithAuthorization } from '@/appsync/lambda/requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import { ErrorInfo } from '@/types/type';
import { StepFunctionStatus } from '@/utils/consts';

export const checkStepFunctionStatus = async (
  executionArn: string
): Promise<StepFunctionStatus> => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.checkStepFunctionStatus}`, {
      executionArn,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00013',
          title: 'Failed to check stepFunction status',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });

  const status = response.data.status;
  return status;
};
